import React, { useEffect, useState, useContext } from 'react';
import InverterWithWeatherList from './InverterWithWeatherList';
import InverterWeatherHistoryList from './InverterWeatherHistoryList';

function WeatherOptimizing() {
    return (
        <div style={{
            display: 'flex',
            width: '100%',
            height: '100%',
        }}>
            <div style={{
                flex: 100,
                border: '3px solid #eee',
                // borderRight: '6px solid #eee',
                padding: 4,
            }}>
                <InverterWithWeatherList style={{}}/>
            </div>
            <div style={{
                flex: 125,
                border: '3px solid #eee',
                padding: 4,
            }}>
                <InverterWeatherHistoryList/>
            </div>
        </div>
    );
}

export default WeatherOptimizing;